"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyResultsNotificationCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const commands_1 = require("../commands");
const SurveyResultsNotificationCard = (survey, userName, notificationType) => {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `${userName} would like you to view the results of this polly!`,
        wrap: true,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: survey.title,
        wrap: true,
        weight: adaptivecards_1.TextWeight.Bolder,
    }));
    card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
        title: "View results",
        isPrimary: true,
        data: (0, commands_1.SurveyResultsViewHTMLCommand)(survey.id, notificationType).toTaskFetchCommand(),
    }));
    return card;
};
exports.SurveyResultsNotificationCard = SurveyResultsNotificationCard;
//# sourceMappingURL=SurveyResultsNotificationCard.js.map